import { createProfessionalExporter } from '../../utils/professionalExport';

function formatDisplayDate(isoDay) {
  const day = String(isoDay || '').slice(0, 10);
  if (!/^\d{4}-\d{2}-\d{2}$/.test(day)) return day || '—';
  const d = new Date(`${day}T12:00:00`);
  if (Number.isNaN(d.getTime())) return day;
  return `${d.getMonth() + 1}/${d.getDate()}/${d.getFullYear()}`;
}

function amountCell(value, { allowZero = false } = {}) {
  const n = Number(value) || 0;
  if (!allowZero && n <= 0) return '';
  return n;
}

function cashBookRows(detail = {}) {
  return (detail.rows || []).map((row) => {
    const isClosing = row.kind === 'closing';
    const isOpening = row.kind === 'opening';
    const allowZero = isOpening || isClosing;
    return [
      row.date ? formatDisplayDate(row.date) : '',
      row.description || '—',
      amountCell(row.receipts, { allowZero: isClosing }),
      amountCell(row.payments, { allowZero: isClosing }),
      amountCell(isClosing ? (row.closingBalance ?? row.balance) : row.balance, { allowZero }),
    ];
  });
}

function makeCashBookExporter({ title, slug }) {
  return createProfessionalExporter({
    title,
    headers: ['Date', 'Description', 'Receipts', 'Payments', 'Balance'],
    slug,
    getRows: (payload) => cashBookRows(payload?.detail || {}),
    getSummary: (payload) => {
      const detail = payload?.detail || {};
      const range = payload?.rangeLabel || '';
      const closing = (detail.rows || []).find((r) => r.kind === 'closing');
      const lines = [];
      if (range) lines.push(`Period: ${range}`);
      lines.push(`Lines: ${(detail.rows || []).length}`);
      if (closing) {
        lines.push(`Closing balance: ${Number(closing.closingBalance ?? closing.balance) || 0}`);
      }
      return lines;
    },
  });
}

const pettyExporter = makeCashBookExporter({
  title: 'Petty Cash Detail',
  slug: 'petty-cash-detail',
});

const bankExporter = makeCashBookExporter({
  title: 'Bank Detail',
  slug: 'bank-detail',
});

export function exportPettyCashDetailExcel(payload) {
  pettyExporter.excel(payload);
}

export function exportPettyCashDetailPdf(payload) {
  pettyExporter.pdf(payload);
}

export function exportBankDetailExcel(payload) {
  bankExporter.excel(payload);
}

export function exportBankDetailPdf(payload) {
  bankExporter.pdf(payload);
}
